export function openFileInNewWindow(url: string) {
  return window.open(url, '_blank');
}
